import { createContext } from "react";
import { DEFAULT_ANALYTICS_CONTEXT_VALUE } from "@swiggy-private/analytics";
import { IAnalyticsSwMoney } from "./interfaces";

const initialValue: IAnalyticsSwMoney = {
    ...DEFAULT_ANALYTICS_CONTEXT_VALUE,
};

const AnalyticsEventContext = createContext<IAnalyticsSwMoney>(initialValue);

export default AnalyticsEventContext;
